import AsignacionesScreen from "../../Screen/ERP/Mantenimiento/OrdenesTrabajo/AsignacionesScreen";
import OrdenesTrabajoScreen from "../../Screen/ERP/Mantenimiento/OrdenesTrabajo/OrdenesTrabajoScreen";
import TipoMantenimientoScreen from "../../Screen/ERP/Mantenimiento/TipoMantenimiento/TipoMantenimientoScreen";
import TipoParoScreen from "../../Screen/ERP/Mantenimiento/TipoParo/TipoParoScreen";
import TipoTrabajoScreen from "../../Screen/ERP/Mantenimiento/TipoTrabajo/TipoTrabajoScreen";

export const MantenimientoRouter = [
  {
    path: "Mantenimiento/TipoTrabajo",
    permiso: 47,
    element: <TipoTrabajoScreen />,
  },
  {
    path: "Mantenimiento/TipoParo",
    permiso: 48,
    element: <TipoParoScreen />,
  },
  {
    path: "Mantenimiento/TipoMantenimiento",
    permiso: 49,
    element: <TipoMantenimientoScreen />,
  },
  {
    path: "Mantenimiento/OrdenTrabajo",
    permiso: 56,
    element: <OrdenesTrabajoScreen />,
  },
  {
    path: "Mantenimiento/Asignaciones",
    permiso: 62,
    element: <AsignacionesScreen />,
  },
];
  
  export default MantenimientoRouter;
  